import React, { Component } from 'react';
import './detectionResSplash.css';
import { FaArrowRight as Arrow } from 'react-icons/lib/fa';
import Anomaly1 from '../../assets/images/anomaly1.png';
import Anomaly2 from '../../assets/images/anomaly2.png';
import Anomaly3 from '../../assets/images/anomaly3.png';

class DetectionSplash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
    };
  }

  handleChange = () => {
    const { isChecked } = this.state;
    this.setState({
      isChecked: ! isChecked,
    });
  }

  handleSubmit = (e) => {
    const { closeModal } = this.props;
    const { isChecked } = this.state;
    e.preventDefault();
    if (isChecked) {
      localStorage.setItem('DontShowDetection', 'true');
    }
    closeModal();
  }

  render() {
    const { isChecked } = this.state;
    return (
      <div className="detection-splashscreen">
        <div className="upper-diagram">
          <div className="get-started">
            <div className="header">
              <h6>How to use the Detection Results</h6>
            </div>
            {/* <div className="steps">
              <ol>
                <li>Create your first model</li>
                <li>Schedule the job which will find anomalies or predict failures, or events.</li>
                <li>See results of all devices withy anomalies/failures.</li>
                <li>Drill-down to a single device to see its details</li>
              </ol>
            </div> */}
          </div>

        </div>
        <div className="lower-diagram">
          <div className="user-flow">
            <p>1</p>
            <Arrow size="21" />
            <p>2</p>
            <Arrow size="21" />
            <p>3</p>
            <hr />
          </div>
          <div className="text-container">
            <div className="status-container">
              <h6>Status Table</h6>
              <div className="status-info">
                <p>
                  {'Here you see the'}
                  <strong> latest device status, </strong>
                  {'including the number of recent anomalies detected.'}
                </p>
              </div>

            </div>
            <div className="analyze-container">
              <h6>Analyze Details</h6>
              <div className="analyze-info">
                <div>
                  {'See'}
                  <strong> detected anomalies </strong>
                  {'(red dots) over time. These have a severe deviation from the normal performance for this property.'}
                  <ul>
                    <li>The first chart shows anomalies based on standard deviation.</li>
                    <li>The second chart shows the absolue value deviations from the norm.</li>
                    <li>The third chart shows the raw data for comparison</li>
                  </ul>
                </div>
              </div>

            </div>
            <div className="action-container">
              <h6>Action</h6>
              <div className="action-info">
                <p>
                  <strong>Add Notes&nbsp;</strong>
                  {'and hide the anomaly if the problem needs no further action.'}
                </p>
              </div>

            </div>

          </div>
        </div>
        <div className="graph-images">
          <img src={Anomaly1} alt="Anomaly Detection Graphs" />
          <img src={Anomaly2} alt="Anomaly Detection Graphs" />
          <img src={Anomaly3} alt="Anomaly Detection Graphs" />
        </div>
        <form onSubmit={this.handleSubmit}
          className="dont-show-container"
        >
          <label htmlFor="check">
            {'Don\'t show this again'}
            <input type="checkbox"
              id="check"
              className="dont-show-check"
              checked={isChecked}
              onChange={this.handleChange}
            />
          </label>
          <button type="submit"
            value="Submit"
          >
            {'Close'}
          </button>
        </form>
      </div>
    );
  }
}
export default DetectionSplash;
